import { useEffect, type ReactNode } from 'react'
import { markHydrated } from '@/lib/earlyClicks'

/**
 * Wraps the whole app: once React has taken over the server-rendered page it marks the page live and replays any
 * click held before then (lib/earlyClicks.ts). Lives outside the entry file, which must not define components (Vite's
 * React refresh would re-run the entry and mount the root twice).
 */
export function Hydrated({ children }: { children: ReactNode }) {
  useEffect(() => markHydrated(), [])
  return children
}
